import AlertPreconfigurationContainer from './alert-preconfiguration-container';

export default AlertPreconfigurationContainer;
